import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { SolutionsSection } from '../components/SolutionsSection';
import { PricingSection } from '../components/PricingSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-493" />
      <ServicesSection data-id="element-494" />
      <SolutionsSection data-id="element-495" />
      <PricingSection data-id="element-496" />
    </>;
}